import { ImageAITransformationInputEntity } from "~/interfaces/entities/ImageAITransformationInput"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: imageAITransformationInputs,
  selectors: imageAITransformationInputsSelectors,
} = createEntitySlice<ImageAITransformationInputEntity>(
  "imageAITransformationInputs"
)
